(() => {
  if (customElements.get('nisplay-country-search')) return;
  customElements.define('nisplay-country-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input[type="search"]');
      const list = this.querySelector('ul');
      const status = this.querySelector('[data-country-status]');
      if (!input || !list) return;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const featured = (this.dataset.featured || '').toUpperCase().split(',').map(s => s.trim()).filter(Boolean);
      const items = Array.from(list.children).filter(li => li.querySelector('[data-popout-option]'));
      const code = li => li.querySelector('[data-popout-option]').dataset.value;
      const rank = li => { const n = featured.indexOf(code(li)); return n < 0 ? Infinity : n; };
      items.sort((a,b) => rank(a) - rank(b) || a.textContent.trim().localeCompare(b.textContent.trim()));
      items.forEach(li => list.append(li));
      const filter = () => {
        const query = normalize(input.value);
        let count = 0;
        items.forEach(li => {
          const iso = code(li);
          const aliases = iso === 'GB' ? 'uk united kingdom britain' : iso === 'US' ? 'usa united states america' : '';
          li.hidden = !normalize(li.textContent + ' ' + iso + ' ' + aliases).includes(query);
          if (!li.hidden) count++;
        });
        status.hidden = count > 0;
        list.scrollTop = 0;
      };
      input.addEventListener('input', filter);
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          items.find(li => !li.hidden)?.querySelector('a')?.focus();
        }
      });
      this.closest('popout-select')?.querySelector('[data-popout-toggle]')?.addEventListener('click', () => {
        input.value = ''; filter();
      });
      this.querySelector('[data-country-search-tools]').hidden = false;
    }
  });
})();
